import { AuthProvider } from '@/lib/auth';
import { AppProvider } from '@/lib/context';
import { NotificationProvider } from '@/lib/notifications';
import { QueryProvider } from '@/lib/reactQuery';
import { UIProvider } from '@/lib/uiContext';
import * as React from 'react';

export const Providers: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <AuthProvider>
      <QueryProvider>
        <AppProvider>
          <UIProvider>
            <NotificationProvider>{children}</NotificationProvider>
          </UIProvider>
        </AppProvider>
      </QueryProvider>
    </AuthProvider>
  );
};
